import { render, staticRenderFns } from "./model_allocation.vue?vue&type=template&id=5848729c&scoped=true&"
import script from "./model_allocation.vue?vue&type=script&lang=js&"
export * from "./model_allocation.vue?vue&type=script&lang=js&"
import style0 from "./model_allocation.vue?vue&type=style&index=0&id=5848729c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848729c",
  null
  
)

export default component.exports